import { Component, inject, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Cls_MobiConfirmationDialog } from "../models";

@Component({
  selector: "mobi-office-lib-confirmation-dialog",
  templateUrl: "./confirmation-dialog.component.html",
  styleUrls: ["./confirmation-dialog.component.scss"],
  standalone: false,
})
export class ConfirmationDialogComponent {
  private dialogRef = inject(MatDialogRef<ConfirmationDialogComponent>);
  private data: Cls_MobiConfirmationDialog = inject(MAT_DIALOG_DATA);

  constructor() {
    this.message = this.data.message;
    this.title = this.data.title;
    this.okButton = this.data.okButton;
    this.cancelButton = this.data.cancelButton;
  }

  message: string = "";
  title: string = "";
  okButton: string = "Confirm";
  cancelButton: string = "Cancel";
}
